// extracted by mini-css-extract-plugin
export default {"wrap":"Benefit_wrap__FAGkz","active":"Benefit_active__-EjWZ"};